import { PrismicRichText } from '@prismicio/react';
import Image from 'next/image';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { Label, Title, Description } from './RankSlice';

import { transformProperties } from '@/src/domains/prismic/helpers';
import { tabletBreakpoint } from '@/src/domains/shared/breakpoints';

export const Section = styled.section`
  background: #fbf9ff;
  ${fluidProp(['padding-bottom', 'padding-top'], '80px', '110px')}
  font-family: var(--typography-fontBossa);
`;

export const ImagesWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const ImageWrapper = styled.div`
  padding-top: 30px;
  display: flex;
  align-items: center;

  ${tabletBreakpoint(css`
    width: 90%;
  `)}
`;

export function GridReportSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { label, title, description, illustration, icon } = primary;

  return (
    <Section id="grid-report">
      <ContentContainer>
        {label && <Label>{label}</Label>}
        {title && (
          <Title>
            <PrismicRichText field={title} />
          </Title>
        )}
        {description && (
          <Description>
            <PrismicRichText field={description} />
          </Description>
        )}
        <ImagesWrapper>
          {illustration && (
            <ImageWrapper>
              <Image
                src={illustration.url}
                alt={illustration.alt || ''}
                width={illustration.dimensions.width}
                height={illustration.dimensions.height}
                quality="100"
              />
            </ImageWrapper>
          )}

          {icon && (
            <ImageWrapper>
              <Image
                src={icon.url}
                alt={icon.alt || ''}
                width={icon.dimensions.width}
                height={icon.dimensions.height}
                quality="100"
              />
            </ImageWrapper>
          )}
        </ImagesWrapper>
      </ContentContainer>
    </Section>
  );
}
